<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->

    <Banner
      title="전문가교육"
      subtitle="전문가교육"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <!-- //서브상단영역 -->

    <BoardNavbar />

    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">전문가 과정</h1>
        <!-- //서브 타이틀영역 -->

        <div class="menu-A-read-wrap">
          <div>
            <ul class="line line4">
              <li>다중재능코칭 전문가교육</li>
              <li>
                <dl class="line2">
                  <dt>제목</dt>
                  <dd>다중재능코칭전문가교육 - 최고과정</dd>
                </dl>
              </li>
            </ul>
          </div>
          <div>
            <ul>
              <li>
                <figure>
                  <n-space justify="center">
                    <img
                      src="@/assets/thum_img/kp708b/sub5_1/96651ace1c81456be2b408cff621fc77_water__c1_w280_h397.jpg"
                      alt=""
                    />
                  </n-space>
                </figure>
              </li>
              <li>
                <dl>
                  <dt>목적</dt>
                  <dd>
                    성장기 유소년, 청소년, 청년을 대상으로 최적의 학습 전략을
                    수립하고 진로를 안내하는 전문가 양성 교육과정으로, <br />
                    PUTT을 활용한 ‘다중재능코칭 전문가’의 교수설계 및 강의
                    역량을 강화하는 데 목적이 있다.
                  </dd>
                </dl>

                <dl>
                  <dt>목표</dt>
                  <dd>
                    목표1. 참여자는 PUTT의 핵심 개념과 용어를 명확하게 이해,
                    정의, 설명하는 기량을 높인다. <br />
                    목표2. 참여자는 PUTT의 구조, 문항, 범위 및 수준, 유형, 결과
                    분석, 그리고 직업군 등 전반에 대한 메타인지를 높인다. <br />
                    목표3. 참여자는 PUTT2.0 전문가 교육(초급 혹은 고급 과정)의
                    교수설계 및 수업 운영 제반 업무 등의 기량을 배양한다.
                  </dd>
                </dl>

                <dl>
                  <dt>대상</dt>
                  <dd>
                    • 교육학 및 심리학 관련 분야 전공자<br />
                    • 교육 및 진로 상담 경력 3년 이상, 혹은 당 분야 박사학위
                    소지자 등<br />
                    • ‘PUTT2.0 학습진로상담전문가 교육: 고급과정’ 이수자로,
                    ‘다중재능코칭전문가 2급 자격증’ 취득한 자
                  </dd>
                </dl>

                <dl class="line2">
                  <dt>구분·시수</dt>
                  <dd>
                    직무연수, 30시간 (사전 과정 6시간 + 집중 과정 22시간 +
                    필기시험 1시간/실기시험 1시간)
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line line4">
              <li>
                결과물<br />
                + 다중재능코칭전문가 1급 자격증
              </li>
              <li>
                <dl class="line2">
                  <dt>구성</dt>
                  <dd>
                    [사전 과정] <br />
                    Ⅰ. PUTT2.0 결과 비교 분석<br />
                    [집중 과정] <br />
                    Ⅱ. 학문적 배경 •21세기 철학과 역량 •검사 이해 •결과리포트의
                    구성 및 해석, •상담 및 코칭<br />
                    Ⅲ. 사례 분석 •사례 분석 - 발표 •사례 분석 - 논의<br />
                    Ⅳ. 교수 설계 • 교수 설계 - 실습 •교수 설계 - 발표 •교수 설계
                    – 논의<br />
                    ⅴ. 수업 계획 • 자료집 - 제작 •자료집 - 발표
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div>
            <ul class="line box22">
              <li>
                강의<br />
                + 검사 개발자<br />
                + ‘PUTT2.0 학습진로상담 전문가교<br />
                육: 최고과정’ 이수자(1급 자격증 소지)
              </li>
              <li>
                <dl class="line2">
                  <dt>이수혜택</dt>
                  <dd>
                    • ‘다중재능코칭전문가 1급 자격증’ 부여<br />
                    • 검사 구매, 결과 해석 및 상담 자격<br />
                    • 특강 자격: 학생 또는 학부모, 진로 상담 전문가
                  </dd>
                </dl>
              </li>
            </ul>
          </div>

          <div class="btn">
            <router-link :to="`${USER_ROUTES.Product.Expert.Expert.Path}`"
              >목록</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardNavbar from "@/views/product/expert/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.menu-A-read-wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  word-break: keep-all;
  box-sizing: border-box;
}
.menu-A-read-wrap > div h1 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.menu-A-read-wrap > div ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu-A-read-wrap > div ul.box22 {
  padding: 20px 0;
}
.menu-A-read-wrap > div ul li {
  width: 100%;
  font-size: 14px;
  line-height: 1.7em;
}

.menu-A-read-wrap > div ul li:nth-child(1) {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
}
.menu-A-read-wrap > div ul li dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 22px 0;
  border-bottom: 1px solid #ddd;
}

.menu-A-read-wrap > div ul li dl dt {
  width: 100%;
  margin-bottom: 10px;
}
.menu-A-read-wrap > div ul li dl dd {
  line-height: 1.7em;
  width: 100%;
}

.menu-A-read-wrap div.btn {
  margin-top: 50px;
  text-align: center;
}
.menu-A-read-wrap div.btn a {
  display: inline-block;
  text-align: center;
  font-size: 15px;
  background: #fff;
  color: #004e31;
  padding: 5px 25px;
  transition: all 0.2s;
  border: 1px solid #004e31;
  font-weight: 500;
}

@media (min-width: 768px) {
  .menu-A-read-wrap > div ul li dl {
    align-items: center;
  }
  .menu-A-read-wrap > div ul li dl.line3 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul.line {
    border-bottom: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li dl.line2 {
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul.line4 {
    border-top: 1px solid #ddd;
  }
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 180px;
    padding: 0;
    text-align: center;
    border-bottom: none;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 200px);
  }
  .menu-A-read-wrap > div ul li {
    font-size: 15px;
  }
  .menu-A-read-wrap > div ul li dl dt {
    width: 80px;
    margin-bottom: 0;
  }
  .menu-A-read-wrap > div ul li dl dd {
    line-height: 1.7em;
    width: calc(100% - 90px);
  }
}

@media screen and (min-width: 1100px) {
  .menu-A-read-wrap > div ul li:nth-child(1) {
    width: 270px;
    padding: 0;
  }
  .menu-A-read-wrap > div ul li:nth-child(2) {
    width: calc(100% - 320px);
  }
}
</style>
